import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
    onActionDelete: (idContaReceber: number | null, openState: boolean) => void,
    statusRecebido: number
}

export const GenerateContasReceberParcialColumns = ({
    onActionDelete,
    statusRecebido

}: Props): GridColDef[] => {


    const columns: GridColDef[] = [
        {
            field: "nomeBancoPagamento",
            filterable: false,
            headerName: "Banco",
            flex: 1,
            minWidth: 50,
            sortable: false,
        },
        {
            field: "dataBaixa",
            filterable: false,
            headerName: "Data Receber",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (!params) return "";
                return new Intl.DateTimeFormat("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }).format(new Date(params));
            },
        },
        {
            field: "formaPagamento",
            filterable: false,
            headerName: "Forma Pagamento",
            flex: 1,
            minWidth: 150,
            sortable: false,
        },
        {
            field: "valorBaixa",
            filterable: false,
            headerName: "Valor Recebido",
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueFormatter: (params) => {
                if (params == null) return "";
                return new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(params);
            },
        }

    ];

    if (statusRecebido == 4) {
        columns.push({
            field: 'idContasReceberParcial',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 150,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">
                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>

                    </div>
                );
            }
        }
        )
    }

    return columns

}